import { CONTACTS } from '../constants';

export const getWhatsAppUrl = (message: string): string => {
  const encodedMessage = encodeURIComponent(message);
  return `${CONTACTS.WHATSAPP.url}?text=${encodedMessage}`;
};
